// extracted by mini-css-extract-plugin
export default {"legalModalBody":"styles_legalModalBody__tMeo6"};